import { Story } from '../../types/story';

export const lateSummerInParis: Story = {
  id: 'late-summer-in-paris',
  title: 'The Wine Bar',
  excerpt: 'Two strangers meet at a wine bar in the Marais, where conversation flows as easily as the Bordeaux.',
  city: 'Paris',
  publishDate: '2025-12-20',
  readTime: '12 min read',
  tags: ['♀♀', 'slow burn', 'wine bar', 'intimate'],
  categories: ['queer', 'romantic'],
  intensity: 2,
  content: `The wine bar was tucked into a narrow street in the Marais, the kind of place you'd walk past three times before noticing the small wooden sign. Inside, it was all exposed brick and dim lighting, with a chalkboard menu that changed daily depending on what the owner felt like serving.

I'd come alone, which wasn't unusual for me. There's something about being alone in a foreign city that feels like permission—to be anyone, to do anything, to shed the weight of who you're supposed to be back home.

She was sitting at the bar when I walked in, her dark hair falling over one shoulder as she studied the wine list. The bartender was explaining something in rapid French, and she was nodding along, though I could tell from the slight furrow in her brow that she was only catching every third word.

"The Côtes du Rhône," I said, sliding onto the stool beside her. "It's excellent here."

She looked up, and I noticed her eyes first—deep brown, with flecks of gold that caught the candlelight. "You speak French?"

"Enough to get by. You're American?"

"Guilty." She smiled, and it transformed her entire face. "I'm Claire."

"Sophie." I offered my hand, and when she took it, her grip was warm and firm.

We talked for hours. About everything and nothing. She was an architect from Boston, here for a conference that had ended two days ago. She'd stayed because she couldn't bear to leave yet, couldn't bear to return to her carefully organized life where everything had its place and its purpose.

I understood that completely.

The wine kept coming—the bartender seemed to sense we were settling in for the evening. Claire told me about the building she was designing, how she wanted to create spaces that made people feel something, not just function efficiently. I told her about my work as a photographer, how I was always chasing light, trying to capture moments that felt true.

"What are you working on now?" she asked, leaning closer. The bar had gotten crowded, and our knees were touching under the counter.

"Honestly? I'm not sure. I've been feeling stuck lately. Like I'm taking the same photo over and over, just in different locations."

"I know that feeling." Her hand found mine on the bar, her fingers tracing small circles on my palm. "Sometimes you need to see things from a completely different angle."

The touch was casual, almost absent-minded, but it sent electricity up my arm. I turned my hand over, lacing my fingers through hers.

"Is this okay?" I asked quietly.

"More than okay."

We left the bar around midnight, stepping out into the warm September air. The streets were still alive with people—couples walking hand in hand, groups of friends laughing over cigarettes, the distant sound of music from an open window.

"My hotel is close," Claire said, and there was a question in her voice.

"Show me."

Her room was small but charming, with tall windows that overlooked a courtyard. She poured us water from a glass bottle, and we stood by the window, looking out at the lights.

"I don't usually do this," she said softly.

"Do what?"

"Invite strangers back to my room. Hold hands with women I just met in wine bars."

I set down my glass and turned to face her. "We don't have to do anything. We can just talk."

"I don't want to just talk." She stepped closer, her hand coming up to cup my cheek. "I want to kiss you. I've wanted to kiss you since you sat down next to me."

"Then kiss me."

She did. Softly at first, tentative, like she was asking permission with every movement. I kissed her back, my hands finding her waist, pulling her closer. She tasted like wine and possibility.

We moved to the bed slowly, taking our time. There was no rush, no urgency—just two people discovering each other in the dim light of a Parisian hotel room. Her skin was soft under my hands, and she made small sounds of pleasure that drove me crazy.

"Tell me what you like," I whispered against her neck.

"This. Exactly this."

We explored each other with a kind of reverent curiosity, learning what made the other gasp, what made us arch into each other's touch. She was generous and attentive, and when she finally made me come, I buried my face in her shoulder to muffle my cries.

Afterward, we lay tangled together, her head on my chest, my fingers running through her hair.

"I leave tomorrow," she said quietly.

"I know."

"Will you give me your number? Your email? Something?"

I thought about it. About the life waiting for me back home, about the person I was there versus the person I was here. About whether some things were meant to stay in the moment, perfect and untouched by reality.

"Let's not," I said finally. "Let's let this be what it is—perfect and complete, just for tonight."

She was quiet for a long moment, then nodded against my chest. "Okay. Just for tonight."

We made love again as the sky began to lighten, slower this time, savoring every touch, every kiss, knowing it was the last. And when I finally slipped out of her room as the sun rose over Paris, I carried the memory of her with me—a perfect moment, suspended in time, never to be repeated but never to be forgotten.

Sometimes the best stories are the ones that end exactly when they should.`
};
